import { render, staticRenderFns } from "./telegram.vue?vue&type=template&id=10ae86fe&"
import script from "./telegram.vue?vue&type=script&lang=js&"
export * from "./telegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports